(function( Handlebars ) {
    window.getInitials = function(string) {
        var names = string.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    };

    window.storageAvailable = function(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return false;
        }
    };

    Array.prototype.removeDuplicates = function () {
        return this.filter(function (item, index, self) {
            return self.indexOf(item) == index;
        });
    };

    // Handlebars
    Handlebars.registerHelper('toLowerCase', function(string) {
        return string.toLowerCase();
    });

    Handlebars.registerHelper('toUpperCase', function(string) {
        return string.toUpperCase();
    });

    Handlebars.registerHelper('capitalizeFirstLetter', function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    });

    Handlebars.registerHelper('getUserInitials', function(user) {
       if (typeof user.name !== 'undefined') {
           return window.getInitials(user.name);
       }
    });

    Handlebars.registerHelper('getAvatar', function(user) {
        if (typeof user.avatar !== 'undefined') {
            return user.avatar;
        };
    });

    Handlebars.registerHelper('limit', function(arr, limit) {
        if (typeof arr !== 'undefined') {
            return arr.slice(0, limit);
        }
    });

})( require('handlebars') );
